<template>
  <div class="my-2 my-md-0">
    <div class="d-flex d-inline-block justify-content-between" v-if="hor.marcacao.paciente">
      <div>
        <div>
          <!--- Nome do Paciente -->
          <span>
            <a href="#" class="card-link" @click.prevent="callback_paciente(hor.marcacao.paciente.search)" v-if="callback_paciente">
              {{ hor.marcacao.paciente.search }}
            </a>
            <span v-else>
              {{ hor.marcacao.paciente.search }}
            </span>
            <span class="badge badge-success" 
              v-if="hor.marcacao.paciente.cadastro && hor.marcacao.paciente.cadastro.idade_anos && ( hor.marcacao.paciente.cadastro.dt_nascimento && hor.marcacao.paciente.cadastro.dt_nascimento.slice(5,10) == $util.hoje().slice(5,10) )" title="Aniversário!">
              {{ hor.marcacao.paciente.cadastro.idade_anos }}a
              <i class="fa-solid fa-cake-candles"></i>
            </span>  

            <span class="badge badge-light"
              v-else-if="hor.marcacao.paciente.cadastro && ( hor.marcacao.paciente.cadastro.idade_anos || hor.marcacao.paciente.cadastro.idade_anos === 0 )" title="idade do paciente">
              {{ hor.marcacao.paciente.cadastro.idade_anos }}a
            </span>  

            <span class="badge badge-info" v-if="hor.marcacao.paciente.cadastro && hor.marcacao.paciente.cadastro.idade_anos >= 80" title="Paciente Idoso">
                80+
            </span>
            
            <span v-if="hor.marcacao.paciente && hor.marcacao.paciente.sinalizadores" class="ml-1">
                <span v-for="(sinal, isx) in hor.marcacao.paciente.sinalizadores" :key="isx" :title="sinal.sinalizador.search">
                    <i class="fa-fw" :class="( sinal.sinalizador.st_icon ? sinal.sinalizador.st_icon : 'fas fa-flag') + ' text-'  + sinal.sinalizador.st_cor" aria-hidden="true"></i>
                </span>
            </span>
          </span>
          
          <!-- Preferencial -->
          <big v-if="hor.marcacao.fl_preferencial">
            <span data-toggle="tooltip" data-placement="top" title="Atendimento Preferencial">
              <i class="fab fa-product-hunt text-danger ml-1" ></i>
            </span>
          </big>

          <!-- Outros Atendimentos -->
          <template v-if="hor.marcacao && hor.marcacao.tem_outras">
            <span data-toggle="tooltip" data-placement="top" title="Outros Atendimentos">
              <i class="fas fa-angle-double-right ml-2"></i>
            </span>
          </template>
        </div>
        <div>
          <a href="#" class="card-link small" @click.prevent="callback_plano(hor.marcacao.plano.search)" v-if="hor.marcacao.plano && callback_plano">
            {{ hor.marcacao.plano.search }}
          </a>
          <small v-else-if="hor.marcacao.plano">{{ hor.marcacao.plano.search }}</small>
          <slot name="plano"></slot>
          <a href="#" @click.prevent="abrir_anexos(hor)" class="card-link m-0" v-if="anexos">
            <span data-toggle2="tooltip" data-placement="top" title="Anexar Arquivos">
              <i class="fa fa-paperclip ml-2" aria-hidden="true" v-if="hor.marcacao && hor.marcacao.paciente && hor.marcacao.paciente.arquivos && hor.marcacao.paciente.arquivos.length"></i>
              <i class="fas fa-plus ml-2" v-else></i>
            </span>
          </a>
        </div>
        <div class="small text-muted" v-if="coleta && hor.marcacao.js_outros_campos && hor.marcacao.js_outros_campos.senha_ch && hor.marcacao.js_outros_campos.senha_ch != hor.marcacao.paciente.search">
          {{ hor.marcacao.js_outros_campos.senha_ch }}
        </div>
      </div>
      <div v-if="showPrint" class="d-print-none" id="acesso-perfil-paciente">
        <paciente-float-panel :paciente="hor.marcacao.paciente" v-if="hor.marcacao.paciente"></paciente-float-panel>
      </div>
    </div>
    <div class="d-flex justify-content-between" v-else-if="hor.marcacao.cadastro_temporario">
      <div>
        <div>
          <span>
            <a href="#" class="card-link" @click.prevent="callback_paciente(hor.marcacao.cadastro_temporario.st_nome)" v-if="callback_paciente">
              {{ hor.marcacao.cadastro_temporario.search }}  
            </a>
            <span v-else>
              {{ hor.marcacao.cadastro_temporario.search }}
            </span>
            <span class="badge badge-success" v-if="hor.marcacao.cadastro_temporario.dt_nascimento && ( hor.marcacao.cadastro_temporario.dt_nascimento.slice(5,10) == $util.hoje().slice(5,10) )" title="Aniversário">
              {{ hor.marcacao.cadastro_temporario.id_a }}a
              <i class="fa-solid fa-cake-candles"></i>
            </span>  
            <span class="badge badge-light" v-else-if="hor.marcacao.cadastro_temporario.id_a || hor.marcacao.cadastro_temporario.id_a === 0" title="idade do paciente">
              {{ hor.marcacao.cadastro_temporario.id_a }}a
            </span>  

            <span class="badge badge-info" v-if="hor.marcacao.cadastro_temporario.id_a >= 80" title="Paciente Idoso">
                80+
            </span>
          </span>
          
          <big v-if="hor.marcacao.fl_preferencial">
            <span data-toggle="tooltip" data-placement="top" title="Atendimento Preferencial">
              <i class="fab fa-product-hunt text-danger ml-1" ></i>
            </span>
          </big>

          <!-- Outros Atendimentos -->
          <template v-if="hor.marcacao && hor.marcacao.tem_outras">
            <span data-toggle="tooltip" data-placement="top" title="Outros Atendimentos">
              <i class="fas fa-angle-double-right ml-2"></i>
            </span>
          </template>
        </div>
        <div v-if="!blockplano">
          <small class="text-muted" v-if="hor.marcacao.plano">{{ hor.marcacao.plano.search }}</small>

          <a href="#" @click.prevent="abrir_anexos(hor, true)" class="card-link m-0" v-if="anexos">
            <span data-toggle2="tooltip" data-placement="top" title="Anexar Arquivos">
              <i class="fa fa-paperclip ml-2" aria-hidden="true" v-if="hor.marcacao && hor.marcacao.cadastro_temporario && hor.marcacao.cadastro_temporario.arquivos && hor.marcacao.cadastro_temporario.arquivos.length"></i>
              <i class="fas fa-plus ml-2" v-else></i>
            </span>
          </a>
        </div>
      </div>
      <div>
        <span class="d-print-none" id="acesso-perfil-paciente">
          <az-float-panel
            classe="left"
            :title="hor.marcacao.cadastro_temporario.st_nome"
            icon="fas fa-id-badge text-secondary"
            :action="abrir_temporario"
        >
            <div>
                <small>
                    {{ hor.marcacao.plano.search }}, 
                    {{ hor.marcacao.cadastro_temporario.ch_sexo }}, 
                    {{ hor.marcacao.cadastro_temporario.idade }}
                </small>
                <div class="small mr-3" v-if="hor.marcacao.cadastro_temporario.dt_nascimento && hor.marcacao.cadastro_temporario.dt_nascimento.substr(0,10) != '1900-01-01'">
                  Dt. Nasc: {{ $util.getFormatDate(hor.marcacao.cadastro_temporario.dt_nascimento) }}
                </div>
                <div v-if="hor.marcacao.cadastro_temporario.st_telefone"> 
                    <i class="fas fa-phone fa-fw mr-1"></i>
                    {{ $util.formatMask(hor.marcacao.cadastro_temporario.st_telefone, 'tel') }}
                </div>
                <div v-if="hor.marcacao.cadastro_temporario.st_celular"> 
                    <i class="fas fa-mobile-alt fa-fw  mr-1"></i>
                    {{ $util.formatMask(hor.marcacao.cadastro_temporario.st_celular, 'cel') }}
                </div>
                <div v-if="hor.marcacao.cadastro_temporario.st_email"> 
                    <i class="far fa-envelope fa-fw  mr-1"></i>
                    {{ hor.marcacao.cadastro_temporario.st_email }}
                </div>
            </div>
          </az-float-panel>
          <!--
          <a href="#" @click.prevent="abrir_temporario(hor.marcacao)">
            <i class="fas fa-id-badge text-secondary"></i>
          </a>
          -->
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import PacienteFloatPanel from "../PacienteFloatPanel.vue";
import AzFloatPanel from '../../util/AzFloatPanel.vue';

export default {
  props: {
    hor: {
      type: Object
    },
    showPrint: {
      type: Boolean,
      default: true
    },
    callback_paciente: { 
      default: null,
    },
    callback_plano: { 
      default: null, 
    },
    blockplano: { 
      type: Boolean,
      default: false, 
    },
    anexos: { 
      type: Boolean,
      default: false, 
    },
    coleta: { 
      type: Boolean,
      default: false, 
    }
  },
  components: {
    PacienteFloatPanel,
    AzFloatPanel
  },
  methods: { 
    abrir_temporario() { 
      if ( this.hor.marcacao.cadastro_temporario.id_cadastro_temporario ) { 
        this.$root.perfil_temp(this.hor.marcacao.cadastro_temporario);
      }
    },

    abrir_anexos (hor, temp = false) { 
      if ( this.$store.state.loading ) 
        return; 

      if ( temp ) { 
        this.$emit('abriranexos', hor.marcacao.cadastro_temporario);  
      } else { 
        this.$emit('abriranexos', hor.marcacao.paciente);
      }
    }
  }
};
</script>